export function selectBotSettingsPage(cookieBotType, envelope) {
  if (cookieBotType === "renovation") {
    return "renovation";
  }
  if (cookieBotType !== "roofing") {
    return "real_estate";
  }
  const settings = envelope && envelope.settings;
  if (settings && settings.bot_type === "roofing_v2") {
    return "roofing_v2";
  }
  if (!settings || settings.bot_type === "roofing_v1" || settings.bot_type === "roofing") {
    return "roofing_v1";
  }
  return "unsupported";
}

export function roofingSettingsGate({ authToken, requestStatus, httpStatus, envelope }) {
  if (requestStatus === "loading") {
    return "loading";
  }
  if (!authToken || httpStatus === 401) {
    return "unauthenticated";
  }
  if (httpStatus === 403) {
    return "forbidden";
  }
  if (requestStatus === "error") {
    return "error";
  }
  return selectBotSettingsPage("roofing", envelope);
}
